import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "message", "confirmButton", "cancelButton"]

  declare readonly modalTarget: HTMLElement
  declare readonly titleTarget: HTMLElement
  declare readonly messageTarget: HTMLElement
  declare readonly confirmButtonTarget: HTMLButtonElement
  declare readonly cancelButtonTarget: HTMLButtonElement
  private resolve: (value: boolean) => void = () => {}

  connect() {
    // Override Turbo's confirm method
    // @ts-ignore
    window.Turbo.setConfirmMethod((message: string, element: HTMLElement) => {
      return this.show(message, element)
    })
  }

  show(message: string, element?: HTMLElement): Promise<boolean> {
    this.titleTarget.textContent         = element?.dataset.confirmTitle   ?? "Are you sure?"
    this.messageTarget.textContent       = message
    this.confirmButtonTarget.textContent = element?.dataset.confirmButton  ?? "Confirm"
    this.cancelButtonTarget.textContent  = element?.dataset.confirmCancel  ?? "Cancel"

    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    document.body.classList.add("overflow-hidden")

    return new Promise((resolve) => {
      this.resolve = resolve
    })
  }

  confirm() {
    this.hide()
    this.resolve(true)
  }

  cancel() {
    this.hide()
    this.resolve(false)
  }

  hide() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    document.body.classList.remove("overflow-hidden")
  }
}
